import { getJwtPayload } from 'utils/analytics';
import localStorageKeys from 'utils/localStorageKeys';

const marketId = getJwtPayload()['http://user/market'];
const language = localStorage.getItem(localStorageKeys.currentLanguage);

export const isNotUSorAPAC = marketId !== 'US' && language !== 'EN-APAC';
export const isNoMarket = marketId === 'NO';
export const isUSMarket = marketId === 'US';
